<main class="content-area main-dashboard">
  <router-outlet></router-outlet>
</main>

<clr-vertical-nav [clr-nav-level]="2" [clrVerticalNavCollapsible]="true" [(clrVerticalNavCollapsed)]="navCollapsed">
  <div style="margin-left: 1em;">
    <app-xconf-dashboard-treeview></app-xconf-dashboard-treeview>
  </div>
</clr-vertical-nav>
